// extracted by mini-css-extract-plugin
export default {"token-holder":"FormFieldMultiSelectWrapper-module__token-holder__1k8zh"};